var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogCategoriesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.6667C17.1088 16.6667 17.5327 16.4911 17.8453 16.1785C18.1578 15.866 18.3334 15.442 18.3334 15V6.66667C18.3334 6.22464 18.1578 5.80072 17.8453 5.48816C17.5327 5.17559 17.1088 5 16.6667 5H10.0834C9.80468 5.00273 9.5297 4.93551 9.28367 4.80448C9.03763 4.67346 8.82838 4.48281 8.67508 4.25L8.00008 3.25C7.84832 3.01956 7.64173 2.8304 7.39883 2.6995C7.15593 2.56859 6.88434 2.50005 6.60841 2.5H3.33341C2.89139 2.5 2.46746 2.67559 2.1549 2.98816C1.84234 3.30072 1.66675 3.72464 1.66675 4.16667V15C1.66675 15.442 1.84234 15.866 2.1549 16.1785C2.46746 16.4911 2.89139 16.6667 3.33341 16.6667H16.6667Z",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogCategoriesIcon);
export default __webpack_public_path__ + "static/media/blog-categories-icon.78ff7464ef7e2fea1cb00cc80d595442.svg";
export { ForwardRef as ReactComponent };